module.exports = __webpack_public_path__ + "static/media/title.57885d1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/imgs/title.png
// module id = 377
// module chunks = 0